import {
  LOADING_START,
  LOADING_END,
  UPDATE_CONFIG,
  UPDATE_FIELDS,
  SUBMITTING_START,
  SUBMITTING_END,
  SUBMITTING_SUCCESS,
  RESET_SUBMISSION,
  SUBMITTING_VALIDATION_ERRORS,
  SUBMITTING_PROCESSING_ERRORS,
  LOADING_FEATURES_START,
  LOADING_FEATURES_SUCCESS,
} from './actions';

import { clearErrors } from './helpers';

export const initialState = {
  config: {
    user: {},
    topics: [],
  },
  loading: true,
  submitting: false,
  submitError: false,
  submitSuccess: false,
  emailAttached: false,
  fields: {
    email: '',
    name: '',
    topic: '',
    subject: '',
    message: '',
    option: '',
    files: [],
    recaptcha: '',
  },
  features: {
    enabled_features: [],
  },
  errors: {},
};

// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, { type, payload }) {
  let fields;
  let errors;
  let email;
  let name;

  switch (type) {
    case LOADING_START:
      return { ...state, loading: true };

    case LOADING_END:
      return { ...state, loading: false };

    case UPDATE_CONFIG:
      email = payload.config.user.email || state.fields.email;
      name = payload.config.user.name || state.fields.name;
      fields = { ...state.fields, email, name };

      return { ...state, config: payload.config, fields };

    case UPDATE_FIELDS:
      fields = { ...state.fields, ...payload.fields };
      errors = { ...state.errors, ...clearErrors(payload.fields) };

      return { ...state, fields, errors };

    case SUBMITTING_START:
      return { ...state, submitting: true, submitError: false };

    case SUBMITTING_END:
      return { ...state, submitting: false };

    case SUBMITTING_SUCCESS:
      return {
        ...state,
        submitSuccess: true,
        emailAttached: !!payload.emailAttached,
      };

    case RESET_SUBMISSION:
      return { ...state, submitSuccess: false };

    case SUBMITTING_VALIDATION_ERRORS:
      return { ...state, errors: payload.errors };

    case SUBMITTING_PROCESSING_ERRORS:
      return { ...state, submitError: true };

    case LOADING_FEATURES_START:
      return state;

    case LOADING_FEATURES_SUCCESS:
      return { ...state, features: payload.features };

    default:
      return state;
  }
}
